import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { colors } from '../../theme';

export const SkilljarFooter = () => {
  return (
    <Stack
      bgcolor={colors.black}
      width="100%"
      alignItems="center"
      p={2}
      gap={1}
    >
      <Typography color="white" fontSize={11} fontWeight={300} align="center">
        © RP Data Pty Limited, trading as Cotality (ABN 67 087 759 171) and
        CoreLogic NZ Limited trading as Cotality (NZCN 1129102){' '}
        {new Date().getFullYear()}. All rights reserved.
      </Typography>
    </Stack>
  );
};
